import { Radio } from "lucide-react";

// Recognizable streaming-platform logos (simple-icons paths). Purely indicative — NOT links.
const STREAM_META = {
  twitch: {
    label: "Twitch",
    color: "#9146FF",
    path: "M2.149 0L.537 4.119v16.836h5.731V24h3.224l2.943-3.045h4.657L23.463 15V0H2.149zm19.164 14.007l-3.582 3.045h-5.731l-2.943 3.044v-3.044H4.298V1.881h17.015v12.126zM17.731 5.016h-1.881v5.731h1.881V5.016zm-5.014 0h-1.881v5.731h1.881V5.016z",
  },
  youtube: {
    label: "YouTube",
    color: "#FF0000",
    path: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  },
  facebook: {
    label: "Facebook",
    color: "#1877F2",
    path: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  },
  tiktok: {
    label: "TikTok",
    color: "#EE1D52",
    path: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
  },
};

export const StreamerBadges = ({ platforms = [], size = 14, showCaption = true }) => {
  const plats = platforms.filter((p) => STREAM_META[p]);
  if (plats.length === 0) return null;
  return (
    <span data-testid="streamer-badge" className="inline-flex items-center gap-1.5 rounded-full border border-[#9146FF]/30 bg-[#9146FF]/10 px-2 py-1">
      {showCaption && (
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#C4B5FD]">
          <Radio size={11} /> Streamer
        </span>
      )}
      {plats.map((p) => {
        const m = STREAM_META[p];
        return (
          <svg key={p} role="img" aria-label={m.label} title={`Streams on ${m.label}`} viewBox="0 0 24 24" width={size} height={size} fill={m.color} data-testid={`streamer-icon-${p}`}>
            <path d={m.path} />
          </svg>
        );
      })}
    </span>
  );
};

export const STREAMER_PLATFORM_KEYS = Object.keys(STREAM_META);
export const STREAMER_PLATFORM_META = STREAM_META;
